import { render, staticRenderFns } from "./WhyChooseSCAD.vue?vue&type=template&id=7f574816&scoped=true&"
import script from "./WhyChooseSCAD.vue?vue&type=script&lang=js&"
export * from "./WhyChooseSCAD.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseSCAD.vue?vue&type=style&index=0&id=7f574816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f574816",
  null
  
)

export default component.exports